<template>
  <div class="sign-in-verify-email-code">
    <back-button :to="{ name: signInRouteName }" />
    <div class="verify-text">
      {{ $t('registration.verify.email.verification.sent') }}
    </div>
    <div class="verify-text email">{{ userEmail }}</div>
    <div class="verify-text check">
      {{ $t('registration.verify.email.check.your.mail') }}
    </div>
    <otp-input
      input-classes="otp-input"
      separator=""
      :num-inputs="6"
      :should-auto-focus="true"
      :is-input-num="true"
      class="otp-code"
      :class="{ 'incorrect-code': error }"
      @on-complete="codeCompelted"
    />
    <div class="resend-message verify-text">
      {{ $t('registration.verify.email.resend.offer') }}
    </div>
    <v-btn class="resend-button" color="primary" @click="onResendClick">{{ $t('resend') }}</v-btn>
    <error-message :errorText="errorMessage" @close="error = null" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OtpInput from '@bachdgvn/vue-otp-input';

import { getAuth, signOut } from '@/amplify/auth';
import { views } from '@/router/constants';
import { SET_AUTH } from '@/store/auth/actionTypes';
import { REQUEST_EMAIL_VERIFICATION, VERIFY_EMAIL } from '@/store/registration/actionTypes';

import ErrorMessage from '@/components/common/ErrorMessage.vue';
import BackButton from '@/components/common/BackButton.vue';

export default {
  name: 'SignInVerifyEmailCode',
  components: {
    BackButton,
    OtpInput,
    ErrorMessage,
  },
  data() {
    return {
      error: '',
    };
  },
  computed: {
    ...mapGetters(['userEmail', 'emailVerificationSent', 'loginDomain']),
    errorMessage() {
      return this.error?.response?.data?.message instanceof Array
        ? this.error?.response?.data?.message?.join('.')
        : this.error?.response?.data?.message || '';
    },
    signInRouteName: () => views.SIGN_IN,
  },
  async mounted() {
    if (!this.emailVerificationSent) {
      let domainOfRegistration = this.loginDomain.domain;
      if (!this.loginDomain.domain) {
        // eslint-disable-next-line prefer-destructuring
        domainOfRegistration = '';
      }
      await this.$store.dispatch(REQUEST_EMAIL_VERIFICATION, domainOfRegistration);
    }
  },
  created() {
    window.addEventListener('beforeunload', this.onLeaving);
  },
  methods: {
    async codeCompelted(code) {
      try {
        await this.$store.dispatch(VERIFY_EMAIL, { code });

        const auth = await getAuth(true);
        await this.$store.dispatch(SET_AUTH, auth);

        this.$router.push({ name: views.DASHBOARD });
      } catch (err) {
        this.error = err;
      }
    },
    async onResendClick() {
      let domainOfRegistration = this.loginDomain.domain;
      if (!this.loginDomain.domain) {
        // eslint-disable-next-line prefer-destructuring
        domainOfRegistration = '';
      }
      await this.$store.dispatch(REQUEST_EMAIL_VERIFICATION, domainOfRegistration);
    },
    async onLeaving() {
      await signOut();
      window.removeEventListener('beforeunload', this.onLeaving);
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.sign-in-verify-email-code .otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 $space-2;
  font-size: $font-size-xl;
  border-radius: $radius-sm;
  border: 1px solid $auth-border;
  text-align: center;
  outline: none;
  &.error {
    border: 1px solid $auth-error !important;
  }

  &:focus {
    border-color: $auth-brand;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp-code div:nth-child(4) .otp-input {
  margin-left: $space-8;
}

.incorrect-code .otp-input {
  border-color: $auth-error;
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.sign-in-verify-email-code {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 130px;
  position: relative;

  .resend-button {
    margin-top: $space-10;
    background-color: $auth-text-muted !important;
    border-color: $auth-text-muted !important;
  }

  .verify-text {
    color: $auth-text-primary;
    font-size: $font-size-md;
    letter-spacing: 0;
    line-height: $space-6;
    text-align: center;
  }

  .email {
    font-weight: bold;
  }

  .check {
    margin-bottom: $space-6;
  }

  .resend-message {
    padding: 0px rem(30);
    margin-top: $space-15;
    text-align: center;
  }

  .back-button {
    position: absolute;
    top: $space-5;
    left: -50px;
    font-size: $font-size-sm;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;

    .v-icon {
      color: $auth-brand;
      margin-right: $space-2;
    }
  }
}
</style>
